import '@babel/polyfill'
import 'whatwg-fetch'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/amplify'
import './plugins/timer'
import './plugins/sweetalert'
import './plugins/print'
import './plugins/validate'
import './plugins/moment'
import './plugins/snotify'
import './plugins/analytics'
import './assets/scripts/config'
// import './assets/scripts/securenow'
import App from './App.vue'
import router from './router'
import store from './store/index'

//Vue.prototype.$axios = dev


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')